import store from "../store";
import { logout } from "../utils/interceptors";
import { FETCH_AUTH_USER } from "../store/types";

export default (to, from, next) => {
  const { isLoggedIn, user } = store.state.auth;
  const currentUser = JSON.parse(localStorage.getItem("user"));
  if (!isLoggedIn) {
    if (to.path == "/dashboard") {
      return next("/login");
    }
    return next();
  } else {
    if (to.path == "/login" 
    || to.path.startsWith("/reset-password")
    || to.path.startsWith("/forgot-password")) {
      return window.location.href = "/dashboard";
    }
    next();
  }
  // token has expired
  if (isLoggedIn && currentUser == null) {
    localStorage.setItem("token_expired", true);
    logout().then(() => {
      window.location.href = "/login";
    })
      .catch(() => {});
  }

  (!user ? store.dispatch(FETCH_AUTH_USER) : Promise.resolve()).then(() => {
    switch (to.path) {
    case "/login":
      return next("/dashboard");
    }
  });
};